import { DSNCQuote } from 'shared-definitions/types'
import { nullableString } from 'shared-code/conversion'
import { ApiComponentQuote } from 'data-source/types.wp'

export function ncQuote(input: ApiComponentQuote): DSNCQuote {
  return {
    resource: 'nc-quote',
    html: input.text,
    author: nullableString(input.author),
  }
}
